import {createAsyncThunk} from '@reduxjs/toolkit';

import api from '../../../services/axios';

export const getNotifications = createAsyncThunk<any, any>(
  'getNotificationsFromApi',
  async ({vendorId = 0}: any) => {
    const response = await api.get(`dashboard/get-notifications?vendorId=${vendorId}`, {
      goBaseUrl: true
    });
    return response.data.data;
  }
);

export const updateNotifications = createAsyncThunk<any, any>(
  'updateNotificationFromApi',
  async ({score_title, vendor_score_id}: any) => {
    const response = await api.post(
      'dashboard/read-notifications',
      {
        vendor_score_id,
        score_title
      },
      {goBaseUrl: true}
    );
    return {data: response.data, score_title};
  }
);

export const getHomeData = createAsyncThunk<any, any>(
  'getHomeDataFromApi',
  async ({vendorId = 0}: any) => {
    const response = await api.get(`dashboard/dashboard-data?VendorId=${vendorId}`, {
      goBaseUrl: true
    });
    return response.data.data;
  }
);

export const getPerformanceScore = createAsyncThunk<any, any>(
  'getPerformanceScore',
  async ({vendorId = 0}: any) => {
    try {
      const response = await api.get(`home-page/performance-score?vendorId=${vendorId}`, {
        goBaseUrl: true
      });
      return response.data.data;
    } catch (e: any) {
      return e?.message || 'Error';
    }
  }
);

export const getOrderCountData = createAsyncThunk<any, any>(
  'getOrderCountData',
  async ({vendorId = 0, thunkApi}: any) => {
    try {
      const response = await api.get(`home-page/order-count?vendorId=${vendorId}`, {
        goBaseUrl: true
      });
      return response.data.data;
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getTopSellData = createAsyncThunk<any, any>(
  'getTopSellData',
  async ({vendorId = 0, thunkApi}: any) => {
    try {
      const response = await api.get(`home-page/top-sell?vendorId=${vendorId}`, {
        goBaseUrl: true
      });
      return response.data.data;
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

//NEW
////////////////////////////////////////////////
export const getWarehouse = createAsyncThunk<any, any>(
  'getWarehouse',
  async ({vendor_id = 0, thunkApi}: any) => {
    try {
      const response = await api.get(`home-page/warehouse?vendor_id=${vendor_id}`, {
        goBaseUrl: true
      });
      return response.data.data;
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getPerformance = createAsyncThunk<any, any>(
  'getPerformance',
  async ({vendor_id = 0, thunkApi}: any) => {
    try {
      const response = await api.get(`home-page/performance?vendor_id=${vendor_id}`, {
        goBaseUrl: true
      });
      return response.data.data;
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getOrderCount = createAsyncThunk<any, any>(
  'getOrderCount',
  async ({vendor_id = 0, thunkApi}: any) => {
    try {
      const response = await api.get(`home-page/order-count?vendor_id=${vendor_id}`, {
        goBaseUrl: true
      });
      return response.data.data;
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getBanners = createAsyncThunk<any, any>(
  'getBanners',
  async ({params, thunkApi}: any) => {
    try {
      const response = await api.get(`dasht/banner`, {
        params,
        goBaseUrl: true
      });

      return response.data;
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);
